module.exports = __webpack_public_path__ + "media/gallery-cookie.bd9839c9.webm";